import Rule from '@/shared/validators/formRules';
import { mapGetters } from "vuex";

export default {
  name: "IntegratorMovementRules",

  data: () => ({
    rule: null,
  }),

  methods: {
    limitSelectionRules(key) {
      if (
        !key ||
        !this.integratorMovementFilter ||
        !this.integratorMovementFilter[key] ||
        this.integratorMovementFilter[key].length === 0
      ) return [];

      return this.rule.handleSelectionLimit(
        this.integratorMovementFilter[key],
        5
      );
    },
  },

  computed: {
    ...mapGetters({
      integratorMovementFilter: 'integrator-movement/integratorMovementFilter'
    }),
    documentRules() {
      if (
        !this.integratorMovementFilter ||
        !this.integratorMovementFilter.document
      ) return [];

      return [ this.rule.cpf ];
    },
    nameRules() {
      if (
        !this.integratorMovementFilter ||
        !this.integratorMovementFilter.name
      ) return [];

      return [
        this.rule.name,
        this.rule.required,
        this.rule.validateIsAlphanumeric
      ];
    },
  },

  created() {
    this.rule = new Rule();
  },
}